// @flow

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Modal from './Modal';
import FileInput from './FileInput';
import { openModal } from './actions';

function Crop() {
  const image = useSelector(state => state.image);
  const dispatch = useDispatch();
  return (
    <div>
      <FileInput />
      <Modal />
      <span>
        <input
          type="hidden"
          value={image}
          name="birthday_child[photo]"
          id="birthday_child_photo"
          data-birthday-children-form-target="field"
        />
        <img style={ { width: "100%"} } src={image} onClick={() => { dispatch(openModal()) } }/>
      </span>
    </div>
  )
}

export default Crop;
